import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "parking-lot-status" },
    [
      _vm.params.data.isInParkingLot || _vm.params.isPastPromotions
        ? _c(VCheckbox, {
            on: { change: _vm.setSelected },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.params.value === _vm.parkingLotStates.planned
        ? _c(VCheckbox, {
            attrs: { disabled: "" },
            model: {
              value: _vm.value,
              callback: function ($$v) {
                _vm.value = $$v
              },
              expression: "value",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.params.value === _vm.parkingLotStates.executed
        ? _c("icon", { attrs: { "icon-name": "locked", small: "" } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }